import { List } from 'antd';
import { t } from 'helpers/i18n';
import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store/reducer';
import AddProjectItem from './AddProjectItem';
import ProjectItem from './ProjectItem';
import './LoadingListSuccessView.scss';
import { Routes } from 'constants/routes';
import { Project } from 'data/terra/Project';

const LoadingListSuccessView: React.FC = () => {
  const history = useHistory();

  const { projects } = useSelector((state: RootState) => state.projectList);
  const listItems = [new AddProjectButton(), ...projects];
  const hasAnyProject = projects.length > 0;

  const onClickProjectItem = useCallback((projectItem: Project) => {
    history.push(`/v2/projects/${projectItem.projectId}/app-config`);
  }, []);

  const onCreateProject = useCallback(() => {
    history.push(Routes.v2_newProject);
  }, []);

  return (
    <div className={'project-list-success-container'}>
      <h1 className="project-list-all-projects-title">
        {t('project_list_your_projects')}
      </h1>
      {!hasAnyProject && <AddProjectItem onClick={onCreateProject} />}
      {hasAnyProject && (
        <List<Project | AddProjectButton>
          grid={{
            xs: 1,
            sm: 2,
            md: 2,
            lg: 3,
            xl: 4,
            xxl: 4,
          }}
          dataSource={listItems}
          renderItem={item => {
            if (item instanceof AddProjectButton) {
              return <AddProjectItem onClick={onCreateProject} />;
            } else {
              return <ProjectItem item={item} onClick={onClickProjectItem} />;
            }
          }}
        />
      )}
    </div>
  );
};

class AddProjectButton {}

export default memo(LoadingListSuccessView);
